<template>
	<div>
		<MemberAuthorizationManager v-if="member" :area="area" :member="member" type="detail" />
	</div>
</template>

<script>
	import toast from '@/util/toast'
	import MemberAuthorizationManager from '@/components/memberAuthorization/MemberAuthorizationManager'

	export default {
		name: 'MemberAuthorization',
		props: {
			member: { type: Object, default: null },
			auth: { type: Object, default: null },
			area: { type: String, default: 'member' },
		},
		data() {
			return {
			}
		},
		components: {
			MemberAuthorizationManager,
		},
		computed: {

		},
		watch: {

		},
		mounted() {

		},
		methods: {

		}
	}
</script>
<style scoped></style>
